/** Large emoji display size from CUU2-3446 acceptance criteria. */
export const LARGE_EMOJI_FONT_SIZE_PX = 40;

/** Code points that only appear as part of an emoji sequence (ZWJ, VS, skin tones, keycap). */
const EMOJI_COMPONENT_REGEX =
  /\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Regional_Indicator}|\uFE0F|\uFE0E|\u200D|\u20E3|[\d#*]/gu;

const graphemeSegmenter =
  typeof Intl !== 'undefined' && 'Segmenter' in Intl
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : null;

/**
 * Returns whether a single code point / character is an emoji-related character.
 */
export const isEmojiChar = (char: string): boolean => {
  if (!char) {
    return false;
  }

  return (
    /\p{Extended_Pictographic}/u.test(char) ||
    /\p{Regional_Indicator}/u.test(char) ||
    /\u20E3/u.test(char)
  );
};

/**
 * Splits text into grapheme clusters (user-perceived characters).
 */
export const getGraphemes = (text: string): string[] => {
  if (graphemeSegmenter) {
    return [...graphemeSegmenter.segment(text)].map(({ segment }) => segment);
  }

  return [...text];
};

/**
 * Returns whether a grapheme cluster is a single emoji
 * (including ZWJ sequences, flags, and keycaps).
 */
export const isEmojiGrapheme = (grapheme: string): boolean => {
  if (!grapheme) {
    return false;
  }

  if (!isEmojiChar(grapheme)) {
    return false;
  }

  // After removing emoji components, nothing non-emoji should remain.
  return grapheme.replace(EMOJI_COMPONENT_REGEX, '').length === 0;
};
